import axios from "axios"
import { toast } from "@/toast"
import { invoicesPath } from "@/api/v2Paths"
import { isSalesforceSubscription } from "@/store/modules/subscription.js"

// Invoices live in two places. Chargebee's come from the legacy endpoint, those of Salesforce
// subscriptions from the v2 one, whose ids carry the same "pphm-" prefix as the subscription ids.
const CHARGEBEE_PATH = "/customer/invoices"
const downloadPath = id => (isSalesforceSubscription(id) ? invoicesPath(id) : `${CHARGEBEE_PATH}/${id}`)

// One list, newest first, each invoice once.
const merge = lists => [...new Map(lists.flat().map(invoice => [invoice.id, invoice])).values()]
  .sort((a, b) => b.date - a.date)

// A document that comes with the response instead of a link: decode it and let the browser save it.
// The API answers content_type; contentType exists only because the response interceptor converts
// the keys to camelCase (interceptor.js).
const saveDocument = ({ content, contentType, filename }) => {
  const bytes = Uint8Array.from(atob(content), char => char.charCodeAt(0))
  const url = URL.createObjectURL(new Blob([bytes], { type: contentType }))
  const anchor = document.createElement("a")
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}

const invoice = {
  namespaced: true,
  state: {
    invoices: [],
  },
  mutations: {
    ADD_INVOICES(state, invoices) {
      state.invoices = invoices
    },
  },
  actions: {
    async fetchAllInvoices({ commit }) {
      const results = await Promise.allSettled([CHARGEBEE_PATH, invoicesPath()].map(url => axios.get(url)))
      // Show what arrived, but say so when a source failed: a customer with both would otherwise
      // take a partial list for the complete one.
      results.filter(({ status }) => status === "rejected").forEach(({ reason }) => toast.error(reason))
      commit("ADD_INVOICES", merge(results.filter(({ status }) => status === "fulfilled").map(({ value }) => value.data)))
    },
    async downloadInvoice(_, { id }) {
      try {
        const { data } = await axios.get(downloadPath(id))
        toast.success("Invoice downloaded.")
        if (data.downloadUrl) {
          window.location.replace(data.downloadUrl)
        }
        else {
          saveDocument(data)
        }
      }
      catch (e) {
        toast.error(e)
      }
    },
  },
}

export {
  invoice,
}
